import { styled } from '@mui/material';

import AgathaMessage from '../../Messages/AgathaMessage';
import LoadingDots from './LoadingDots';

const LoadingMessageWithDots = () => {
  // @Nick TODO: support live chat
  //   const isActiveLiveChat = useAppSelector(selectIsActiveLiveChat);

  return (
    <AgathaLoadingMessage
      hideBackground={true}
      isAuthorIconVisible
      isLiveChat={false}
      stepIndex={-1}
    >
      <LoadingDots />
    </AgathaLoadingMessage>
  );
};

const AgathaLoadingMessage = styled(AgathaMessage)`
  background-color: ${props => props.theme.palette.colors.slate[100]};
  min-height: 0;
  width: 61px;
  height: 35px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  left: 0px;
  border-radius: 25px;
`;

export default LoadingMessageWithDots;
